<template>
  <div class="setting_content">
    <div class="setting_content_main setting_category">
      <form @change="logChangeData">
        <h2 class="setting_content_title">
          {{ mailLabelsProperties.TAB_HEADER }}
        </h2>
        <div class="setting_unit">
          <div class="setting_unit_item customize_unit">
            <div class="setting_balloon_rows_label">
              {{ mailLabelsProperties.LABEL_FROM_ADDRESS }}
              <p class="setting_label">
                {{ screenLabelsProperties.REQUIRE_LABEL }}
              </p>
            </div>
            <div class="setting_unit_form">
              <div class="setting_form_select_wrapper">
                <select
                  class="setting_form_select"
                  v-model="draftMail.user"
                  @change="validateInputAccount"
                >
                  <option :value="{id: 0, email:'', isDeleted: false}">{{entryLabelProperties.OPTION_SELECT_DEFAULT}}</option>
                  <option
                    v-for="(user, index) in users.filter(user => user.email)"
                    :key="index"
                    :value="{id: user.id, email: user.email, isDeleted: user.isDeleted}"
                  >
                    {{ user.display_name }} <span v-if="user && user.isDeleted" :class="user && user.isDeleted ? 'item_deleted':''">{{mailMessagesProperties.ACCOUNT_MAIL_DELETED}}</span>  &lt;{{user.email}}&gt;
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ mailLabelsProperties.AUTO_MAIL_SUBJECT_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                "
                v-model="draftMail.emailTitle"
                @input="validateInputSubject()"
              />
              <h6 v-show="lengthErrorSubject" class="error-message">
                {{ mailSettingsProperties.AUTO_MAIL_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>

          <div class="entry_mail_setting">
            <p class="setting_unit_title">
              {{ mailLabelsProperties.ENTRY_AUTO_MAIL_HEADER }}
            </p>
            <p class="setting_unit_explain">
              {{ mailLabelsProperties.ENTRY_AUTO_MAIL_SUB_HEADER }}
            </p>
            <div class="setting_unit_item">
              <p class="setting_unit_label">
                {{ mailLabelsProperties.ENTRY_AUTO_MAIL_BODY_INPUT_TITLE }}
              </p>
              <div class="setting_unit_form">
                <textarea
                  class="setting_form_textarea"
                  :placeholder="mailLabelsProperties.ENTRY_AUTO_MAIL_BODY_PLACEHOLDER"
                  v-model="draftMail.emailBody"
                  @input="validateInputBodyMail()"
                ></textarea>
                <h6 v-show="lengthErrorBodyMail" class="error-message">
                  {{ mailSettingsProperties.BODY_MAIL_MAX_LENGTH }}
                  {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                </h6>
              </div>
            </div>
            <div class="setting_unit">
              <p class="setting_unit_title">
                {{ mailLabelsProperties.ENTRY_LABEL_REPLACE_MAIL_HEADER }}
              </p>
              <p class="setting_unit_explain">
                {{ mailLabelsProperties.ENTRY_LABEL_REPLACE_MAIL_SUB_HEADER }}
              </p>
              <div class="setting_mail_input_replace d-flex flex-wrap">
                <p class="setting_unit_label_customize">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_TEXT_TITLE }}
                </p>
                <p class="setting_unit_label">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_ITEM_TITLE }}
                </p>
              </div>
              <div class="setting_unit_form">
                <div v-for="(mailReplace, indexMail) in computedMailReplace" :key="indexMail">
                  <div class="setting_form_wrapper mt-2">
                    <input
                      class="setting_form_text setting_key_replace mr-2"
                      type="text"
                      :placeholder="
                        mailLabelsProperties.LABEL_REPLACE_KEY_PLACEHOLDER
                      "
                      v-model="mailReplace.keyReplace"
                      @input="validateInputReplaceKey(ITEM_ENTRY)"
                    />
                    <draggable
                      :list="mailReplace.itemReplaces"
                      draggable=".item"
                      :group="{
                        name: 'item-job-or-candidate',
                        put: checkSettingsLength(indexMail, ITEM_ENTRY) === 0,
                      }"
                      @add="addItemToMailReplace(indexMail, ITEM_ENTRY)"
                      class="setting_draagle_item"
                    >
                      <div
                        v-for="(mailReplace, index) in mailReplace.itemReplaces"
                        :key="index"
                        class="item"
                      >
                        <div class="setting_form_wrapper" v-if="mailReplace">
                          <input
                            class="setting_form_text"
                            type="text"
                            :placeholder="
                              mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                            "
                            v-model="mailReplace.display_name"
                            readonly
                          />
                          <div
                            class="setting_form_wrapper_close"
                            @click="deleteItemMailReplace(indexMail, ITEM_ENTRY, mailReplace)"
                          >
                            <svg
                              width="12"
                              height="12"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g fill="none" fill-rule="evenodd">
                                <rect fill="#555" width="12" height="12" rx="2" />
                                <g fill="#FFF">
                                  <path
                                    d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                  />
                                  <path
                                    d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="footer"
                        class="setting_form_wrapper"
                        v-if="checkSettingsLength(indexMail, ITEM_ENTRY) === 0"
                      >
                        <input
                          class="setting_form_text"
                          type="text"
                          :placeholder="
                            mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                          "
                          v-model="mailReplace.display_name"
                          readonly
                        />
                      </div>
                    </draggable>
                    <div
                        class="setting_form_wrapper_delete"
                        v-if="indexMail >= 1"
                        @click="removeEmailReplace(indexMail, ITEM_ENTRY, mailReplace)"
                    >
                      <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#AAA" fill-rule="evenodd">
                          <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                          <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <p
                    v-show="lengthErrorReplaceKeys.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailSettingsProperties.KEY_REPLACE_MAX_LENGTH }}
                    {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                  </p>
                  <p
                    v-show="formatErrorReplaceKeys.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailMessagesProperties.KEY_REPLACE_WRONG_FORMAT }}
                  </p>
                </div>
                <div class="setting_unit_add">
                  <div
                    class="setting_unit_add_btn"
                    @click.prevent="addEmailReplace(ITEM_ENTRY)"
                  >
                    {{ mailLabelsProperties.LABEL_ADD_MAIL_REPLACE }}
                  </div>
                </div>
                <div v-for="(keyDuplicate, index) in keyDuplicates" :key="index">
                  <p
                    v-if="keyDuplicate && keyDuplicate.length > 1"
                    class="error-message"
                  >
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_START }}
                    {{ keyDuplicate }}
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_END }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <template v-if="hp_renkei_job === 1">
          <div class="job_mail_setting">
            <p class="setting_unit_title">
              {{ mailLabelsProperties.JOB_AUTO_MAIL_HEADER }}
            </p>
            <p class="setting_unit_explain">
              {{ mailLabelsProperties.JOB_AUTO_MAIL_SUB_HEADER }}
            </p>
            <div class="setting_unit_item">
              <p class="setting_unit_label">
                {{ mailLabelsProperties.JOB_AUTO_MAIL_BODY_INPUT_TITLE }}
              </p>
              <div class="setting_unit_form">
                <textarea
                  class="setting_form_textarea"
                  :placeholder="mailLabelsProperties.JOB_AUTO_MAIL_BODY_PLACEHOLDER"
                  v-model="draftMail.emailBodyJob"
                  @input="validateInputBodyMailJob(); checkEmptyForm()"
                ></textarea>
                <h6 v-show="lengthErrorBodyMailJob" class="error-message">
                  {{ mailSettingsProperties.BODY_MAIL_MAX_LENGTH }}
                  {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                </h6>
                <h6 v-show="isExistJobFormError && draftMail.emailBodyJob.length !== 0" class="error-message">
                  {{ errorProperties.BODY_MAIL_EMPTY_JOB_FORM }}
                </h6>
              </div>
            </div>
            <div class="setting_unit">
              <p class="setting_unit_title">
                {{ mailLabelsProperties.JOB_LABEL_REPLACE_MAIL_HEADER }}
              </p>
              <p class="setting_unit_explain">
                {{ mailLabelsProperties.JOB_LABEL_REPLACE_MAIL_SUB_HEADER }}
              </p>
              <div class="setting_mail_input_replace d-flex flex-wrap">
                <p class="setting_unit_label_customize">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_TEXT_TITLE }}
                </p>
                <p class="setting_unit_label">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_ITEM_TITLE }}
                </p>
              </div>
              <div class="setting_unit_form">
                <div v-for="(mailReplace, indexMail) in computedMailReplaceJob" :key="indexMail">
                  <div class="setting_form_wrapper mt-2">
                    <input
                      class="setting_form_text setting_key_replace mr-2"
                      type="text"
                      :placeholder="
                        mailLabelsProperties.LABEL_REPLACE_KEY_PLACEHOLDER
                      "
                      v-model="mailReplace.keyReplace"
                      @input="validateInputReplaceKey(ITEM_JOB)"
                    />
                    <draggable
                      :list="mailReplace.itemReplaces"
                      draggable=".item"
                      :group="{
                        name: 'item-job-or-candidate',
                        put: checkSettingsLength(indexMail, ITEM_JOB) === 0,
                      }"
                      @add="addItemToMailReplace(indexMail, ITEM_JOB)"
                      class="setting_draagle_item"
                    >
                      <div
                        v-for="(mailReplace, index) in mailReplace.itemReplaces"
                        :key="index"
                        class="item"
                      >
                        <div class="setting_form_wrapper" v-if="mailReplace">
                          <input
                            class="setting_form_text"
                            type="text"
                            :placeholder="
                              mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                            "
                            v-model="mailReplace.display_name"
                            readonly
                          />
                          <div
                            class="setting_form_wrapper_close"
                            @click="deleteItemMailReplace(indexMail, ITEM_JOB, mailReplace)"
                          >
                            <svg
                              width="12"
                              height="12"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g fill="none" fill-rule="evenodd">
                                <rect fill="#555" width="12" height="12" rx="2" />
                                <g fill="#FFF">
                                  <path
                                    d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                  />
                                  <path
                                    d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="footer"
                        class="setting_form_wrapper"
                        v-if="checkSettingsLength(indexMail, ITEM_JOB) === 0"
                      >
                        <input
                          class="setting_form_text"
                          type="text"
                          :placeholder="
                            mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                          "
                          v-model="mailReplace.display_name"
                          readonly
                        />
                      </div>
                    </draggable>
                    <div
                        class="setting_form_wrapper_delete"
                        v-if="indexMail >= 1"
                        @click="removeEmailReplace(indexMail, ITEM_JOB, mailReplace)"
                    >
                      <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#AAA" fill-rule="evenodd">
                          <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                          <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <p
                    v-show="lengthErrorReplaceKeysJob.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailSettingsProperties.KEY_REPLACE_MAX_LENGTH }}
                    {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                  </p>
                  <p
                    v-show="formatErrorReplaceKeysJob.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailMessagesProperties.KEY_REPLACE_WRONG_FORMAT }}
                  </p>
                </div>
                <div class="setting_unit_add">
                  <div
                    class="setting_unit_add_btn"
                    @click.prevent="addEmailReplace(ITEM_JOB)"
                  >
                    {{ mailLabelsProperties.LABEL_ADD_MAIL_REPLACE }}
                  </div>
                </div>
                <div v-for="(keyDuplicate, index) in keyDuplicatesJob" :key="index">
                  <p
                    v-if="keyDuplicate && keyDuplicate.length > 1"
                    class="error-message"
                  >
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_START }}
                    {{ keyDuplicate }}
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_END }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          </template>

          <template v-if="hp_renkei_job === 1 && is_plan_dispatch_basic === 1">
          <div class="dispatch_job_setting">
            <p class="setting_unit_title">
              {{ mailLabelsProperties.DISPATCH_JOB_AUTO_MAIL_HEADER }}
            </p>
            <p class="setting_unit_explain">
              {{ mailLabelsProperties.DISPATCH_JOB_AUTO_MAIL_SUB_HEADER }}
            </p>
            <div class="setting_unit_item">
              <p class="setting_unit_label">
                {{ mailLabelsProperties.DISPATCH_JOB_AUTO_MAIL_BODY_INPUT_TITLE }}
              </p>
              <div class="setting_unit_form">
                <textarea
                  class="setting_form_textarea"
                  :placeholder="mailLabelsProperties.DISPATCH_JOB_AUTO_MAIL_BODY_PLACEHOLDER"
                  v-model="draftMail.emailBodyDispatch"
                  @input="validateInputBodyMailDispatch(); checkEmptyForm()"
                ></textarea>
                <h6 v-show="lengthErrorBodyMailDispatch" class="error-message">
                  {{ mailSettingsProperties.BODY_MAIL_MAX_LENGTH }}
                  {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                </h6>
                <h6 v-show="isExistDispatchFormError && draftMail.emailBodyDispatch.length !== 0" class="error-message">
                  {{ errorProperties.BODY_MAIL_EMPTY_DISPATCH_JOB_FORM }}
                </h6>
              </div>
            </div>
            <div class="setting_unit">
              <p class="setting_unit_title">
                {{ mailLabelsProperties.DISPATCH_JOB_LABEL_REPLACE_MAIL_HEADER }}
              </p>
              <p class="setting_unit_explain">
                {{ mailLabelsProperties.DISPATCH_JOB_LABEL_REPLACE_MAIL_SUB_HEADER }}
              </p>
              <div class="setting_mail_input_replace d-flex flex-wrap">
                <p class="setting_unit_label_customize">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_TEXT_TITLE }}
                </p>
                <p class="setting_unit_label">
                  {{ mailLabelsProperties.LABEL_MAIL_INPUT_ITEM_TITLE }}
                </p>
              </div>
              <div class="setting_unit_form">
                <div v-for="(mailReplace, indexMail) in computedMailReplaceDispatch" :key="indexMail">
                  <div class="setting_form_wrapper mt-2">
                    <input
                      class="setting_form_text setting_key_replace mr-2"
                      type="text"
                      :placeholder="
                        mailLabelsProperties.LABEL_REPLACE_KEY_PLACEHOLDER
                      "
                      v-model="mailReplace.keyReplace"
                      @input="validateInputReplaceKey(ITEM_DISPATCH_JOB)"
                    />
                    <draggable
                      :list="mailReplace.itemReplaces"
                      draggable=".item"
                      :group="{
                        name: 'item-job-or-candidate',
                        put: checkSettingsLength(indexMail, ITEM_DISPATCH_JOB) === 0,
                      }"
                      @add="addItemToMailReplace(indexMail, ITEM_DISPATCH_JOB)"
                      class="setting_draagle_item"
                    >
                      <div
                        v-for="(mailReplace, index) in mailReplace.itemReplaces"
                        :key="index"
                        class="item"
                      >
                        <div class="setting_form_wrapper" v-if="mailReplace">
                          <input
                            class="setting_form_text"
                            type="text"
                            :placeholder="
                              mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                            "
                            v-model="mailReplace.display_name"
                            readonly
                          />
                          <div
                            class="setting_form_wrapper_close"
                            @click="deleteItemMailReplace(indexMail, ITEM_DISPATCH_JOB, mailReplace)"
                          >
                            <svg
                              width="12"
                              height="12"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g fill="none" fill-rule="evenodd">
                                <rect fill="#555" width="12" height="12" rx="2" />
                                <g fill="#FFF">
                                  <path
                                    d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                  />
                                  <path
                                    d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="footer"
                        class="setting_form_wrapper"
                        v-if="checkSettingsLength(indexMail, ITEM_DISPATCH_JOB) === 0"
                      >
                        <input
                          class="setting_form_text"
                          type="text"
                          :placeholder="
                            mailLabelsProperties.LABEL_MAIL_REPLACE_PLACEHOLDER
                          "
                          v-model="mailReplace.display_name"
                          readonly
                        />
                      </div>
                    </draggable>
                    <div
                        class="setting_form_wrapper_delete"
                        v-if="indexMail >= 1"
                        @click="removeEmailReplace(indexMail, ITEM_DISPATCH_JOB, mailReplace)"
                    >
                      <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#AAA" fill-rule="evenodd">
                          <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                          <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <p
                    v-show="lengthErrorReplaceKeysDispatch.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailSettingsProperties.KEY_REPLACE_MAX_LENGTH }}
                    {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                  </p>
                  <p
                    v-show="formatErrorReplaceKeysDispatch.includes(indexMail)"
                    class="error-message clearfix"
                  >
                    {{ mailMessagesProperties.KEY_REPLACE_WRONG_FORMAT }}
                  </p>
                </div>
                <div class="setting_unit_add">
                  <div
                    class="setting_unit_add_btn"
                    @click.prevent="addEmailReplace(ITEM_DISPATCH_JOB)"
                  >
                    {{ mailLabelsProperties.LABEL_ADD_MAIL_REPLACE }}
                  </div>
                </div>
                <div v-for="(keyDuplicate, index) in keyDuplicatesDispatch" :key="index">
                  <p
                    v-if="keyDuplicate && keyDuplicate.length > 1"
                    class="error-message"
                  >
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_START }}
                    {{ keyDuplicate }}
                    {{ mailMessagesProperties.MESSAGE_DUPLICATE_KEY_END }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          </template>
        </div>

        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ mailLabelsProperties.NOTIFICATION_MAIL_HEADER }}
          </p>
          <p class="setting_unit_explain">
            {{ mailLabelsProperties.NOTIFICATION_MAIL_SUB_HEADER_1 }}<br />
            {{ mailLabelsProperties.NOTIFICATION_MAIL_SUB_HEADER_2 }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ mailLabelsProperties.LABEL_MAIL_ENTRY_SUCCESS }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                "
                v-model="draftMail.emailSubject"
                @input="validateInputEmailSubject()"
              />
              <h6 v-show="lengthErrorEmailSubject" class="error-message">
                {{ mailSettingsProperties.AUTO_MAIL_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ mailLabelsProperties.LABEL_MAIL_ENTRY_ERROR }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  mailLabelsProperties.AUTO_MAIL_SUBJECT_PLACEHOLDER
                "
                v-model="draftMail.errorEmailTitle"
                @input="validateInputErrorEmailTitle()"
              />
              <h6 v-show="lengthErrorEmailErrorTitle" class="error-message">
                {{ mailSettingsProperties.AUTO_MAIL_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ mailLabelsProperties.NOTIFICATION_MAIL_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <div
                v-for="(mail, index) in draftMail.emailAccounts"
                :key="index"
              >
                <div class="setting_form_wrapper">
                  <input
                    class="setting_form_text mt-2"
                    type="text"
                    :placeholder="
                      mailLabelsProperties.NOTIFICATION_MAIL_PLACEHOLDER
                    "
                    v-model="mail.emailAccount"
                    @input="validateInputEmail()"
                  />
                  <div
                    class="setting_form_wrapper_delete"
                    v-if="index >= 1"
                    @click="removeEmail(index)"
                  >
                    <svg
                      width="12"
                      height="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="#AAA" fill-rule="evenodd">
                        <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"></path>
                        <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <p
                  v-show="lengthErrorEmails.includes(index)"
                  class="error-message clearfix"
                >
                  {{ mailSettingsProperties.MAIL_MAX_LENGTH }}
                  {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
                </p>
                <p
                  v-if="isWrongFormatEmail.includes(index)"
                  class="error-message clearfix"
                >
                  {{ errorProperties.WRONG_MAIL_FORMAT }}
                </p>
              </div>
              <div class="setting_unit_add">
                <a
                  class="setting_unit_add_btn"
                  v-if="
                    draftMail.emailAccounts.length <
                    mailSettingsProperties.MAX_NUMBER_MAIL
                  "
                  @click.prevent="addEmail()"
                >
                  {{ mailLabelsProperties.ADD_NOTIFICATION_MAIL_LINK }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div>
      <div class="setting_content_sub" id="menu-search-item-mail-tab">
        <div class="setting_human_resource">
          <div id="entry_heading_search_item_mail">
            <div class="setting_options_search d-flex justify-content-end">
              <div class="setting_item_display_arrow evt-click" :class="isHideItemEntry? '':'is_open'"
                  @click.prevent="hideItemReource(ITEM_ENTRY)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <button
                class="setting_btn_secondary setting_btn_medium"
                @click="refreshResourceList"
              >
                {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
              </button>
            </div>
            <div class="setting_options_search">
              <p class="setting_options_search_label">
                {{ screenLabelsProperties.SEARCH_LABEL }}
              </p>
              <div class="setting_options_search_box">
                <input
                  class="setting_form_text"
                  type="text"
                  :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
                  v-model="computedPropertyHumanResource"
                  v-on:keyup.enter="getHumanResourceFields"
                />
                <button
                  class="setting_btn_primary"
                  v-on:click.prevent="getHumanResourceFields"
                >
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                      <circle
                        stroke="#FFF"
                        stroke-width="2"
                        cx="6.5"
                        cy="6.5"
                        r="5.5"
                      />
                      <path
                        fill="#FFF"
                        d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"
                      />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
            <div class="setting_options_search setting_options_search_customize">
              <p class="setting_unit_annotation">
                {{ screenLabelsProperties.ANNOTATION_ITEM_ENTRY_MAIL_SETTING_TAB }}
              </p>
            </div>
          </div>
          <div class="setting_options_wrapper" id="entry_item_resource_wrap_mail" style="display: block;">
            <div class="setting_options_category">
              <div v-for="(candidateCategory, indexCategory) in humanCandidateCategories" :key="indexCategory">
                <template v-if="checkEmptyResourceCategory(computedHumanResourceFields, candidateCategory.name, true) && candidateCategory.is_display === 1">
                  <p class="setting_options_category_name candidates mt-3">
                    {{ candidateCategory.display_name }}
                  </p>
                  <draggable :group="{ name: 'item-job-or-candidate', put: false, pull: 'clone' }" :clone="cloneResource" :sort="false" :list="computedHumanResourceFields">
                    <template v-for="resourceField in computedHumanResourceFields">
                      <div v-if="resourceField.property_category_name === candidateCategory.name && resourceField.isUsed"
                           class="setting_options_category_item" @mousedown="checkAvailableDragDrop('entry')">
                        <svg class="setting_options_category_item_icon" width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <span class="setting_options_category_item_name" v-text="resourceField.display_name"></span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_job_resource" v-if="hp_renkei_job === 1">
          <div id="job_heading_search_item_mail">
            <div class="setting_options_search_job_resource d-flex justify-content-end">
              <div class="setting_item_display_arrow evt-click" :class="isHideItemJob ? '':'is_open'"
                  @click.prevent="hideItemReource(ITEM_JOB)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <button class="setting_btn_secondary setting_btn_medium" @click="refreshJobResourceList">
                {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
              </button>
            </div>
            <div class="setting_options_search_job_resource setting_options_search_customize">
              <p class="setting_options_search_label">
                {{ screenLabelsProperties.SEARCH_JOB_LABEL }}
              </p>
              <div class="setting_options_search_box">
                <input
                  class="setting_form_text"
                  type="text"
                  :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
                  v-model="computedPropertyJobResource"
                  v-on:keyup.enter="getJobResourceFields"
                />
                <button class="setting_btn_primary" v-on:click.prevent="getJobResourceFields">
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                      <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                      <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="setting_options_wrapper" id="job_item_resource_wrap_mail" style="display: block;">
            <div class="setting_options_category">
              <template v-for="jobCategory in jobCategories">
                <template v-if="checkEmptyResourceCategory(computedJobResourceFields, jobCategory.name, false) && jobCategory.is_display === 1">
                  <p class="setting_options_category_name jobs mt-3">
                    {{ jobCategory.display_name }}
                  </p>
                  <draggable :group="{ name: 'item-job-or-candidate', put: false, pull: 'clone'}" :clone="cloneResourceJob" :sort="false" :list="computedJobResourceFields">
                    <template v-for="resourceField in computedJobResourceFields">
                      <div v-if="resourceField.property_category_name === jobCategory.name && resourceField.isUsed && !resourceField.isUsedMailTab" class="setting_options_category_item"
                           @mousedown="checkAvailableDragDrop('job')">
                        <svg class="setting_options_category_item_icon" width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <span class="setting_options_category_item_name" v-text="resourceField.display_name"></span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="setting_job_resource" v-if="hp_renkei_job === 1 && is_plan_dispatch_basic === 1">
          <div id="dispatch_job_heading_search_item_mail">
            <div class="setting_options_search_job_resource d-flex justify-content-end">
              <div class="setting_item_display_arrow evt-click" :class="isHideItemDispatchJob ? '':'is_open'"
                   @click.prevent="hideItemReource(ITEM_DISPATCH_JOB)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <button class="setting_btn_secondary setting_btn_medium" @click="refreshDispatchJobResourceList">
                {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
              </button>
            </div>
            <div class="setting_options_search_job_resource setting_options_search_customize">
              <p class="setting_options_search_label">
                {{ screenLabelsProperties.SEARCH_DISPATCH_JOB_LABEL }}
              </p>
              <div class="setting_options_search_box">
                <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
                    v-model="computedPropertyDispatchJobResource"
                    v-on:keyup.enter="getDispatchJobResourceFields"
                />
                <button class="setting_btn_primary" v-on:click.prevent="getDispatchJobResourceFields">
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                      <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                      <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="setting_options_wrapper" id="dispatch_job_item_resource_wrap_mail" style="display: block;">
            <div class="setting_options_category">
              <template v-for="jobCategory in dispatchJobCategories">
                <template v-if="checkEmptyResourceCategory(computedDispatchJobResourceFields, jobCategory.name, false) && jobCategory.is_display === 1">
                  <p class="setting_options_category_name jobs mt-3">
                    {{ jobCategory.display_name }}
                  </p>
                  <draggable :group="{ name: 'item-job-or-candidate', put: false, pull: 'clone'}" :clone="cloneResourceDispatch" :sort="false" :list="computedDispatchJobResourceFields">
                    <template v-for="resourceField in computedDispatchJobResourceFields">
                      <div v-if="resourceField.property_category_name === jobCategory.name && resourceField.isUsed && !resourceField.isUsedMailTab" class="setting_options_category_item"
                      @mousedown="checkAvailableDragDrop('dispatch')">
                        <svg class="setting_options_category_item_icon" width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <span class="setting_options_category_item_name" v-text="resourceField.display_name"></span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mailLabelsProperties from "../../../properties/entry_screen/mail_tab/mail-labels.json";
import mailSettingsProperties from "../../../properties/entry_screen/mail_tab/mail-maxlength-settings.json";
import errorProperties from "../../../properties/entry_screen/errors.json";
import screenLabelsProperties from "../../../properties/entry_screen/screen_tab/screen-labels.json";
import draggable from "vuedraggable";
import generalService from "../../../services/GeneralService";
import mailMessagesProperties from "../../../properties/entry_screen/mail_tab/messages.json";
import generalLabelProperties from "../../../properties/general_page/generalpage-labels.json"
import entryLabelProperties from "../../../properties/entry_screen/entry_screen.json"
import entrySettingNotificationProperty from "../../../properties/entry_screen/notifications.json";
import VueToast from "vue-toast-notification";
import Vue from "vue";
import {printf} from "fast-printf";

Vue.use(VueToast);

const ITEM_JOB = 5;
const ITEM_DISPATCH_JOB = 7;
const ITEM_ENTRY = 6;

export default {
  name: "MailTab",
  props: [
    "mail",
    "mailError",
    "humanResourceFields",
    "humanCandidateCategories",
    "jobResourceFields",
    "jobCategories",
    "dispatchJobResourceFields",
    "dispatchJobCategories",
    "propertyJobResource",
    "propertyHumanResource",
    "propertyDispatchJobResource",
    "mailReplaces",
    "mailReplacesJob",
    "mailReplacesDispatch",
    "groupName",
    "users",
    "userId",
    "hp_renkei_job",
    "is_plan_dispatch_basic"
  ],
  components: {
    draggable,
  },
  data() {
    return {
      lengthErrorBodyMail: false,
      lengthErrorBodyMailJob: false,
      lengthErrorBodyMailDispatch: false,
      errorAccount: false,
      lengthErrorSubject: false,
      lengthErrorEmailSubject: false,
      lengthErrorEmailErrorTitle: false,
      isWrongFormatEmail: [],
      lengthErrorEmails: [],
      lengthErrorReplaceKeys: [],
      lengthErrorReplaceKeysJob: [],
      lengthErrorReplaceKeysDispatch: [],
      formatErrorReplaceKeys:[],
      formatErrorReplaceKeysJob:[],
      formatErrorReplaceKeysDispatch:[],
      draftMail: {
        emailTitle: "",
        errorEmailTitle: "",
        emailBody: "",
        emailBodyJob: "",
        emailBodyDispatch: "",
        emailSubject: "",
        user: {
          id:-1,
          emailAccount: "",
          isDeleted:false
        },
        emailAccounts: [
          {
            emailAccount: "",
          },
        ],
      },
      mailSettingsProperties: mailSettingsProperties,
      mailLabelsProperties: mailLabelsProperties,
      errorProperties: errorProperties,
      screenLabelsProperties: screenLabelsProperties,
      mailMessagesProperties: mailMessagesProperties,
      entryLabelProperties:entryLabelProperties,
      generalLabelProperties:generalLabelProperties,
      log: {
        info: {},
      },
      keyDuplicates: {},
      keyDuplicatesJob: {},
      keyDuplicatesDispatch: {},
      hasKeyDuplicate: false,
      hasKeyDuplicateJob: false,
      hasKeyDuplicateDispatch: false,
      isHideItemJob: false,
      isHideItemDispatchJob: false,
      isHideItemEntry: false,
      ITEM_JOB: ITEM_JOB,
      ITEM_DISPATCH_JOB: ITEM_DISPATCH_JOB,
      ITEM_ENTRY: ITEM_ENTRY,
      selectedItem: -1,
      isExistJobFormError: false,
      isExistDispatchFormError: false
    };
  },
  watch: {
    draftMail: {
      handler() {
        this.validateInputAccount();
        this.validateInputReplaceKey(ITEM_ENTRY);
        this.validateInputReplaceKey(ITEM_JOB);
        this.validateInputReplaceKey(ITEM_DISPATCH_JOB);
        this.validateInputSubject();
        this.validateInputEmailSubject();
        this.validateInputErrorEmailTitle();
        this.validateInputBodyMail();
        this.validateInputBodyMailJob();
        this.validateInputBodyMailDispatch();
        this.checkEmptyForm();
        this.logChangeData();
      },
      deep: true,
    },
  },
  computed: {
    computedMailError: {
      get() {
        return this.mailError;
      },
      set(value) {
        this.$emit("updateMailError", value);
      },
    },
    computedHumanResourceFields: {
      get() {
        return this.humanResourceFields;
      },
      set(value) {
        this.$emit("updateResourceField", value);
      },
    },
    computedPropertyHumanResource: {
      get() {
        return this.propertyHumanResource;
      },
      set(value) {
        this.$emit("updatedPropertyHumanResource", value);
      },
    },
    computedJobResourceFields: {
      get() {
        return this.jobResourceFields;
      },
      set(value) {
        this.$emit("updateJobResourceField", value);
      },
    },
    computedPropertyJobResource: {
      get() {
        return this.propertyJobResource;
      },
      set(value) {
        this.$emit("updatedPropertyJobResource", value);
      },
    },
    computedDispatchJobResourceFields: {
      get() {
        return this.dispatchJobResourceFields;
      },
      set(value) {
        this.$emit("updateDispatchJobResourceField", value);
      },
    },
    computedPropertyDispatchJobResource: {
      get() {
        return this.propertyDispatchJobResource;
      },
      set(value) {
        this.$emit("updatedPropertyDispatchJobResource", value);
      },
    },
    computedMailReplace: {
      get() {
        return this.mailReplaces;
      },
      set(value) {
        this.$emit("updatedReplaceMail", value);
      },
    },
    computedMailReplaceJob: {
      get() {
        return this.mailReplacesJob;
      },
      set(value) {
        this.$emit("updatedReplaceMailJob", value);
      },
    },
    computedMailReplaceDispatch: {
      get() {
        return this.mailReplacesDispatch;
      },
      set(value) {
        this.$emit("updatedReplaceMailDispatch", value);
      },
    },
  },
  mounted() {
    this.validateInputAccount();
    this.validateInputReplaceKey(ITEM_ENTRY);
    this.validateInputReplaceKey(ITEM_JOB);
    this.validateInputReplaceKey(ITEM_DISPATCH_JOB);
    this.validateInputSubject();
    this.validateInputEmailSubject();
    this.validateInputErrorEmailTitle();
    this.validateInputBodyMail();
    this.validateInputBodyMailJob();
    this.validateInputBodyMailDispatch();
    this.checkEmptyForm();
    this.draftMail = this.mail;
  },
  methods: {
    hideItemReource(typeOfItem){
      let heightOfMenu = this.getHeightMenuSearch();
      let elementJobHeadingSearch = document.getElementById("job_heading_search_item_mail");
      let elementDispatchJobHeadingSearch = document.getElementById("dispatch_job_heading_search_item_mail");
      let elementEntryHeadingSearch = document.getElementById("entry_heading_search_item_mail");

      if(!elementEntryHeadingSearch){
        return;
      }
      let boundEntryHeadingSearch = elementEntryHeadingSearch.getBoundingClientRect();
      let boundJobHeadingSearch = elementJobHeadingSearch ? elementJobHeadingSearch.getBoundingClientRect() : {height: 0};
      let boundDispatchJobHeadingSearch = elementDispatchJobHeadingSearch ? elementDispatchJobHeadingSearch.getBoundingClientRect() : {height: 0};
      let heightFinal = heightOfMenu - (boundEntryHeadingSearch.y + boundEntryHeadingSearch.height);

      let entryHeight = boundEntryHeadingSearch.height;
      let jobHeight = boundJobHeadingSearch.height;
      let dispatchJobHeight = boundDispatchJobHeadingSearch.height;

      let elementHideItemJob = document.getElementById("job_item_resource_wrap_mail");
      let elementHideItemDispatchJob = document.getElementById("dispatch_job_item_resource_wrap_mail");
      let elementHideItemEntry = document.getElementById("entry_item_resource_wrap_mail");

      if(!elementHideItemEntry){
        return;
      }
      let isDisplayJob = elementHideItemJob ? elementHideItemJob.style.display : "";
      let isDisplayDispatchJob = elementHideItemDispatchJob ? elementHideItemDispatchJob.style.display : "";
      let isDisplayEntry = elementHideItemEntry.style.display;

      switch (typeOfItem) {
        case ITEM_JOB:
          this.isHideItemJob = !this.isHideItemJob;
          isDisplayJob = this.isHideItemJob ? 'none':'block';
          break;
        case ITEM_DISPATCH_JOB:
          this.isHideItemDispatchJob = !this.isHideItemDispatchJob;
          isDisplayDispatchJob = this.isHideItemDispatchJob ? 'none':'block';
          break;
        case ITEM_ENTRY:
          this.isHideItemEntry = !this.isHideItemEntry;
          isDisplayEntry = this.isHideItemEntry ? 'none':'block';
          break;
      }

      if(!this.isHideItemEntry && !this.isHideItemJob && !this.isHideItemDispatchJob){
        heightFinal = (heightFinal + entryHeight + dispatchJobHeight)/3;
      }
      elementHideItemEntry.setAttribute("style", "display: " + isDisplayEntry + ";height: "+ (heightFinal - jobHeight - dispatchJobHeight) + "px !important");
      if(elementHideItemJob){
        elementHideItemJob.setAttribute("style","display: " + isDisplayJob + ";height: "+ (heightFinal - entryHeight - dispatchJobHeight) + "px !important");
      }
      if(elementHideItemDispatchJob){
        elementHideItemDispatchJob.setAttribute("style", "display: " + isDisplayDispatchJob + ";height: "+ (heightFinal - jobHeight - entryHeight) + "px !important");
      }
      this.$emit("updateSrollMenu","");
    },

    getHeightMenuSearch(){
      let windowInnerHeight = window.innerHeight;
      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      if(!elementFooter){
        return;
      }
      return (windowInnerHeight - elementFooter.height);
    },

    addItemToMailReplace(indexMail, type){
      switch (type) {
        case ITEM_ENTRY:
          if(this.computedMailReplace[indexMail] && this.computedMailReplace[indexMail].itemReplaces){
            this.computedMailReplace[indexMail].itemReplaces.forEach((item, index) => {
              this.computedMailReplace[indexMail].itemReplaces[index] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplace[indexMail].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0){
              this.validateInputReplaceKey(ITEM_ENTRY);
            }

            switch (this.selectedItem) {
              case ITEM_ENTRY:
                this.computedMailReplace[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_ENTRY && this.computedMailReplace.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_ENTRY).length > 1) {
                    Vue.$toast.clear();
                    Vue.$toast.warning(
                        printf(entrySettingNotificationProperty.EXIST_ITEM_ENTRY_REPLACE, this.computedMailReplace[indexMail].itemReplaces[0].display_name), {
                          position: "bottom-right",
                          duration: 3000,
                          queue: true
                        }
                    );
                    this.computedMailReplace[indexMail].itemReplaces = [];
                  }
                });
                break;
              case ITEM_JOB:
                this.computedMailReplace[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_JOB) {
                    this.computedMailReplace[indexMail].itemReplaces = [];
                  }
                });
                this.warningDragDropItem(ITEM_ENTRY);
                break;
              case ITEM_DISPATCH_JOB:
                this.computedMailReplace[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_DISPATCH_JOB) {
                    this.computedMailReplace[indexMail].itemReplaces = [];
                  }
                });
                this.warningDragDropItem(ITEM_ENTRY);
                break;
            }
          }
          break;
        case ITEM_JOB:
          if(this.computedMailReplaceJob[indexMail] && this.computedMailReplaceJob[indexMail].itemReplaces){
            this.computedMailReplaceJob[indexMail].itemReplaces.forEach((item, index) => {
              this.computedMailReplaceJob[indexMail].itemReplaces[index] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplaceJob[indexMail].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0 && this.jobResourceFields && this.jobResourceFields.length > 0){
              this.updateStatusItemUsed(this.jobResourceFields, itemReplace, "updateJobResourceField");
              this.validateInputReplaceKey(ITEM_JOB);
            }

            switch (this.selectedItem) {
              case ITEM_DISPATCH_JOB:
                this.computedMailReplaceJob[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_DISPATCH_JOB) {
                    this.computedMailReplaceJob[indexMail].itemReplaces = [];
                    if (this.computedMailReplaceJob.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_JOB).length === 0) {
                      this.jobResourceFields.filter(resource => resource.name === itemSetting.name && resource.display_name === itemSetting.display_name).forEach(resource => resource.isUsedMailTab = false);
                      this.$emit("updateJobResourceField", JSON.parse(JSON.stringify(this.dispatchJobResourceFields)));
                    }
                  }
                });

                this.warningDragDropItem(ITEM_JOB);
                break;
              case ITEM_ENTRY:
                this.computedMailReplaceJob[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_ENTRY) {
                    if (this.computedMailReplaceJob.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_JOB).length === 0) {
                      this.jobResourceFields.filter(resource => resource.name === itemSetting.name && resource.display_name === itemSetting.display_name).forEach(resource => resource.isUsedMailTab = false);
                      this.$emit("updateJobResourceField", JSON.parse(JSON.stringify(this.jobResourceFields)));
                    }

                    if (this.computedMailReplaceJob.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_ENTRY).length > 1) {
                      Vue.$toast.clear();
                      Vue.$toast.warning(
                          printf(entrySettingNotificationProperty.EXIST_ITEM_ENTRY_REPLACE, this.computedMailReplaceJob[indexMail].itemReplaces[0].display_name), {
                            position: "bottom-right",
                            duration: 3000,
                            queue: true
                          }
                      );
                      this.computedMailReplaceJob[indexMail].itemReplaces = [];
                    }
                  }
                });

                break;
            }

            break;
          }

          this.checkEmptyForm();
          break;
        case ITEM_DISPATCH_JOB:
          if(this.computedMailReplaceDispatch[indexMail] && this.computedMailReplaceDispatch[indexMail].itemReplaces){
            this.computedMailReplaceDispatch[indexMail].itemReplaces.forEach((item, index) => {
              this.computedMailReplaceDispatch[indexMail].itemReplaces[index] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplaceDispatch[indexMail].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0 && this.dispatchJobResourceFields && this.dispatchJobResourceFields.length > 0){
              this.updateStatusItemUsed(this.dispatchJobResourceFields, itemReplace, "updateDispatchJobResourceField");
              this.validateInputReplaceKey(ITEM_DISPATCH_JOB);
            }

            switch (this.selectedItem) {
              case ITEM_JOB:
                this.computedMailReplaceDispatch[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_JOB) {
                    this.computedMailReplaceDispatch[indexMail].itemReplaces = [];
                    if (this.computedMailReplaceDispatch.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_DISPATCH_JOB).length === 0) {
                      this.dispatchJobResourceFields.filter(resource => resource.name === itemSetting.name && resource.display_name === itemSetting.display_name).forEach(resource => resource.isUsedMailTab = false);
                      this.$emit("updateDispatchJobResourceField", JSON.parse(JSON.stringify(this.dispatchJobResourceFields)));
                    }
                  }
                });

                this.warningDragDropItem(ITEM_DISPATCH_JOB);
                break;
              case ITEM_ENTRY:
                this.computedMailReplaceDispatch[indexMail].itemReplaces.forEach(itemSetting => {
                  if (itemSetting.resourceType && itemSetting.resourceType === ITEM_ENTRY) {
                    if (this.computedMailReplaceDispatch.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_DISPATCH_JOB).length === 0) {
                      this.dispatchJobResourceFields.filter(resource => resource.name === itemSetting.name && resource.display_name === itemSetting.display_name).forEach(resource => resource.isUsedMailTab = false);
                      this.$emit("updateDispatchJobResourceField", JSON.parse(JSON.stringify(this.dispatchJobResourceFields)));
                    }

                    if (this.computedMailReplaceDispatch.filter(mailReplace => mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].name === itemSetting.name && mailReplace.itemReplaces[0].resourceType === ITEM_ENTRY).length > 1) {
                      Vue.$toast.clear();
                      Vue.$toast.warning(
                          printf(entrySettingNotificationProperty.EXIST_ITEM_ENTRY_REPLACE, this.computedMailReplaceDispatch[indexMail].itemReplaces[0].display_name), {
                            position: "bottom-right",
                            duration: 3000,
                            queue: true
                          }
                      );
                      this.computedMailReplaceDispatch[indexMail].itemReplaces = [];
                    }
                  }
                });

                break;
            }

            break;
          }

          this.checkEmptyForm();
          break;
      }

      this.$eventBus.$emit("unSaved", true);
    },

    updateStatusItemUsed(resourceFields, itemReplace, updateResourceFields){
      resourceFields.filter((resource) => resource.name === itemReplace[0].name && resource.display_name === itemReplace[0].display_name)
        .forEach((resource) => {
          resource.isUsedMailTab = true;
        });
      this.$emit(updateResourceFields, JSON.parse(JSON.stringify(resourceFields)));
    },

    checkSettingsLength(index, type) {
      switch (type){
        case ITEM_ENTRY:
          if (this.computedMailReplace[index] && this.computedMailReplace[index].itemReplaces) {
            return this.computedMailReplace[index].itemReplaces.filter(replaceMailSetting => replaceMailSetting).length;
          }
          break;
        case ITEM_JOB:
          if (this.computedMailReplaceJob[index] && this.computedMailReplaceJob[index].itemReplaces) {
            return this.computedMailReplaceJob[index].itemReplaces.filter(replaceMailSetting => replaceMailSetting).length;
          }
          break;
        case ITEM_DISPATCH_JOB:
          if (this.computedMailReplaceDispatch[index] && this.computedMailReplaceDispatch[index].itemReplaces) {
            return this.computedMailReplaceDispatch[index].itemReplaces.filter(replaceMailSetting => replaceMailSetting).length;
          }
          break;
      }

      return 0;
    },

    deleteItemMailReplace(index, type, mailReplace) {
      this.getItemAndResetStatus(index, mailReplace.resourceType);
      switch (type) {
        case ITEM_ENTRY:
          if (this.computedMailReplace[index]) {
            this.computedMailReplace[index].itemReplaces = [];
          }
          this.computedMailReplace = JSON.parse(
              JSON.stringify(this.computedMailReplace)
          );
          break;
        case ITEM_JOB:
          if (this.computedMailReplaceJob[index]) {
            this.computedMailReplaceJob[index].itemReplaces = [];
          }

          this.computedMailReplaceJob = JSON.parse(JSON.stringify(this.computedMailReplaceJob));
          this.checkEmptyForm();
          break;
        case ITEM_DISPATCH_JOB:
          if (this.computedMailReplaceDispatch[index]) {
            this.computedMailReplaceDispatch[index].itemReplaces = [];
          }

          this.computedMailReplaceDispatch = JSON.parse(JSON.stringify(this.computedMailReplaceDispatch));
          this.checkEmptyForm();
          break;
      }

      this.$eventBus.$emit("unSaved", true);
    },

    removeEmailReplace(index, type, mailReplace) {
      this.getItemAndResetStatus(index, mailReplace.itemReplaces.length > 0 && mailReplace.itemReplaces[0].resourceType ? mailReplace.itemReplaces[0].resourceType : -1);
      switch (type) {
        case ITEM_ENTRY:
          this.computedMailReplace.splice(index, 1);
          break;
        case ITEM_JOB:
          this.computedMailReplaceJob.splice(index, 1);
          this.checkEmptyForm();
          break;
        case ITEM_DISPATCH_JOB:
          this.computedMailReplaceDispatch.splice(index, 1);
          this.checkEmptyForm();
          break;
      }

      this.validateInputReplaceKey(type);
      this.$eventBus.$emit("unSaved", true);
    },

    getItemAndResetStatus(index, type){
      switch (type) {
        case ITEM_ENTRY:
          if (this.computedMailReplace[index] && this.computedMailReplace[index].itemReplaces) {
            this.computedMailReplace[index].itemReplaces.forEach((item, indexMail) => {
              this.computedMailReplace[index].itemReplaces[indexMail] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplace[index].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0){
              this.resetStatusItemUsed(this.humanResourceFields, itemReplace, "updateHumanResourceField");
            }
          }
          break;
        case ITEM_JOB:
          if (this.computedMailReplaceJob[index] && this.computedMailReplaceJob[index].itemReplaces) {
            this.computedMailReplaceJob[index].itemReplaces.forEach((item, indexMail) => {
              this.computedMailReplaceJob[index].itemReplaces[indexMail] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplaceJob[index].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0){
              this.resetStatusItemUsed(this.jobResourceFields, itemReplace, "updateJobResourceField");
            }
          }
          break;
        case ITEM_DISPATCH_JOB:
          if (this.computedMailReplaceDispatch[index] && this.computedMailReplaceDispatch[index].itemReplaces) {
            this.computedMailReplaceDispatch[index].itemReplaces.forEach((item, indexMail) => {
              this.computedMailReplaceDispatch[index].itemReplaces[indexMail] = JSON.parse(JSON.stringify(item));
            })
            let itemReplace = this.computedMailReplaceDispatch[index].itemReplaces.filter(itemSetting => itemSetting);
            if(itemReplace && itemReplace.length > 0 && this.humanResourceFields && this.humanResourceFields.length > 0){
              this.resetStatusItemUsed(this.dispatchJobResourceFields, itemReplace, "updateDispatchJobResourceField");
            }
          }
          break;
      }
    },

    resetStatusItemUsed(resourceFields, itemReplace, updateResourceFields){
      resourceFields.filter((resource) => resource.name === itemReplace[0].name && resource.display_name === itemReplace[0].display_name)
        .forEach((resource) => {
          resource.isUsedMailTab = false;
        });
      this.$emit(updateResourceFields, JSON.parse(JSON.stringify(resourceFields)));
    },

    validateInputReplaceKey(type) {
      this.$eventBus.$emit("unSaved", true);
      let countDuplicateError = 0;
      switch (type) {
        case ITEM_ENTRY:
          this.keyDuplicates = {};
          this.computedMailReplace.forEach((mailReplace, index) => {
            this.keyDuplicates[mailReplace.keyReplace] =
                this.keyDuplicates[mailReplace.keyReplace] || [];
            if (mailReplace.keyReplace.length > 0) {
              this.keyDuplicates[mailReplace.keyReplace].push(index + 1);
            }
          });
          for (const [key, value] of Object.entries(this.keyDuplicates)) {
            if (key && value.length > 1) countDuplicateError++;
          }

          this.hasKeyDuplicate = countDuplicateError > 0;
          this.lengthErrorReplaceKeys = [];
          for (let i = 0; i < this.computedMailReplace.length; i++) {
            if (this.computedMailReplace[i].keyReplace.length > this.mailSettingsProperties.KEY_REPLACE_MAX_LENGTH) {
              if (this.lengthErrorReplaceKeys.includes(i)) {
                continue;
              }

              this.lengthErrorReplaceKeys.push(i);
            } else {
              const indexOfKey = this.lengthErrorReplaceKeys.indexOf(i);
              if (indexOfKey !== -1) {
                this.lengthErrorReplaceKeys.splice(indexOfKey, 1);
              }
            }
          }
          this.checkFormatKeyReplace(ITEM_ENTRY);
          break;
        case ITEM_JOB:
          this.keyDuplicatesJob = {};
          this.computedMailReplaceJob.forEach((mailReplace, index) => {
            this.keyDuplicatesJob[mailReplace.keyReplace] = this.keyDuplicatesJob[mailReplace.keyReplace] || [];
            if (mailReplace.keyReplace.length > 0) {
              this.keyDuplicatesJob[mailReplace.keyReplace].push(index + 1);
            }
          });
          for (const [key, value] of Object.entries(this.keyDuplicatesJob)) {
            if (key && value.length > 1) countDuplicateError++;
          }

          this.hasKeyDuplicateJob = countDuplicateError > 0;
          this.lengthErrorReplaceKeysJob = [];
          for (let i = 0; i < this.computedMailReplaceJob.length; i++) {
            if (this.computedMailReplaceJob[i].keyReplace.length > this.mailSettingsProperties.KEY_REPLACE_MAX_LENGTH) {
              if (this.lengthErrorReplaceKeysJob.includes(i)) {
                continue;
              }

              this.lengthErrorReplaceKeysJob.push(i);
            } else {
              const indexOfKey = this.lengthErrorReplaceKeysJob.indexOf(i);
              if (indexOfKey !== -1) {
                this.lengthErrorReplaceKeysJob.splice(indexOfKey, 1);
              }
            }
          }
          this.checkFormatKeyReplace(ITEM_JOB);
          break;
        case ITEM_DISPATCH_JOB:
          this.keyDuplicatesDispatch = {};
          this.computedMailReplaceDispatch.forEach((mailReplace, index) => {
            this.keyDuplicatesDispatch[mailReplace.keyReplace] =
                this.keyDuplicatesDispatch[mailReplace.keyReplace] || [];
            if (mailReplace.keyReplace.length > 0) {
              this.keyDuplicatesDispatch[mailReplace.keyReplace].push(index + 1);
            }
          });
          for (const [key, value] of Object.entries(this.keyDuplicatesDispatch)) {
            if (key && value.length > 1) countDuplicateError++;
          }

          this.hasKeyDuplicateDispatch = countDuplicateError > 0;
          this.lengthErrorReplaceKeysDispatch = [];
          for (let i = 0; i < this.computedMailReplaceDispatch.length; i++) {
            if (this.computedMailReplaceDispatch[i].keyReplace.length > this.mailSettingsProperties.KEY_REPLACE_MAX_LENGTH) {
              if (this.lengthErrorReplaceKeysDispatch.includes(i)) {
                continue;
              }

              this.lengthErrorReplaceKeysDispatch.push(i);
            } else {
              const indexOfKey = this.lengthErrorReplaceKeysDispatch.indexOf(i);
              if (indexOfKey !== -1) {
                this.lengthErrorReplaceKeysDispatch.splice(indexOfKey, 1);
              }
            }
          }
          this.checkFormatKeyReplace(ITEM_DISPATCH_JOB);
          break;
      }

      this.checkError();
    },

    checkFormatKeyReplace(type){
      const regex = /^{{([\w]+)}{2}$/g;
      switch (type) {
        case ITEM_ENTRY:
          this.formatErrorReplaceKeys = [];
          for (let i = 0; i < this.computedMailReplace.length; i++) {
            let keyReplace  = this.computedMailReplace[i].keyReplace;
            if(keyReplace && (!keyReplace.match(regex) || keyReplace.match(regex).length === 0)){
              if (this.formatErrorReplaceKeys.includes(i)) {
                continue;
              }
              this.formatErrorReplaceKeys.push(i);
            } else {
              const indexOfKey = this.formatErrorReplaceKeys.indexOf(i);
              if (indexOfKey !== -1) {
                this.formatErrorReplaceKeys.splice(indexOfKey, 1);
              }
            }
          }
          break;
        case ITEM_JOB:
          this.formatErrorReplaceKeysJob = [];
          for (let i = 0; i < this.computedMailReplaceJob.length; i++) {
            let keyReplace  = this.computedMailReplaceJob[i].keyReplace;
            if(keyReplace && (!keyReplace.match(regex) || keyReplace.match(regex).length === 0)){
              if (this.formatErrorReplaceKeysJob.includes(i)) {
                continue;
              }
              this.formatErrorReplaceKeysJob.push(i);
            } else {
              const indexOfKey = this.formatErrorReplaceKeysJob.indexOf(i);
              if (indexOfKey !== -1) {
                this.formatErrorReplaceKeysJob.splice(indexOfKey, 1);
              }
            }
          }
          break;
        case ITEM_DISPATCH_JOB:
          this.formatErrorReplaceKeysDispatch = [];
          for (let i = 0; i < this.computedMailReplaceDispatch.length; i++) {
            let keyReplace  = this.computedMailReplaceDispatch[i].keyReplace;
            if(keyReplace && (!keyReplace.match(regex) || keyReplace.match(regex).length === 0)){
              if (this.formatErrorReplaceKeysDispatch.includes(i)) {
                continue;
              }
              this.formatErrorReplaceKeysDispatch.push(i);
            } else {
              const indexOfKey = this.formatErrorReplaceKeysDispatch.indexOf(i);
              if (indexOfKey !== -1) {
                this.formatErrorReplaceKeysDispatch.splice(indexOfKey, 1);
              }
            }
          }
          break;
      }

    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    validateInputSubject() {
      this.lengthErrorSubject =
        this.draftMail.emailTitle.length >
        this.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH;
      if (!this.lengthErrorSubject) {
        this.mail.titleMail = this.draftMail.emailTitle;
      }

      this.checkError();
    },

    validateInputEmailSubject() {
      this.lengthErrorEmailSubject =
          this.draftMail.emailSubject.length >
          this.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH;
      if (!this.lengthErrorEmailSubject) {
        this.mail.emailSubject = this.draftMail.emailSubject;
      }

      this.checkError();
    },

    validateInputErrorEmailTitle() {
      this.lengthErrorEmailErrorTitle =
          this.draftMail.errorEmailTitle.length >
          this.mailSettingsProperties.AUTO_MAIL_MAX_LENGTH;
      if (!this.lengthErrorEmailErrorTitle) {
        this.mail.errorEmailTitle = this.draftMail.errorEmailTitle;
      }

      this.checkError();
    },

    validateInputBodyMail() {
      this.lengthErrorBodyMail =
        this.draftMail.emailBody.length >
        this.mailSettingsProperties.BODY_MAIL_MAX_LENGTH;
      if (!this.lengthErrorBodyMail) {
        this.mail.bodyMail = this.draftMail.emailBody;
      }

      this.checkError();
    },

    validateInputBodyMailJob() {
      this.lengthErrorBodyMailJob = this.draftMail.emailBodyJob.length > this.mailSettingsProperties.BODY_MAIL_MAX_LENGTH;
      if (!this.lengthErrorBodyMailJob) {
        this.mail.emailBodyJob = this.draftMail.emailBodyJob;
      }

      this.checkError();
    },

    validateInputBodyMailDispatch() {
      this.lengthErrorBodyMailDispatch = this.draftMail.emailBodyDispatch.length > this.mailSettingsProperties.BODY_MAIL_MAX_LENGTH;
      if (!this.lengthErrorBodyMailDispatch) {
        this.mail.emailBodyDispatch = this.draftMail.emailBodyDispatch;
      }

      this.checkError();
    },

    validateInputEmail() {
      this.isWrongFormatEmail = [];
      this.lengthErrorEmails = [];
      for (let i = 0; i < this.draftMail.emailAccounts.length; i++) {
        if (
          this.draftMail.emailAccounts[i].emailAccount.length >
          this.mailSettingsProperties.MAIL_MAX_LENGTH
        ) {
          if (this.lengthErrorEmails.includes(i)) {
            continue;
          }

          this.lengthErrorEmails.push(i);
        } else {
          const indexOfMail = this.lengthErrorEmails.indexOf(i);
          if (indexOfMail !== -1) {
            this.lengthErrorEmails.splice(indexOfMail, 1);
          }
        }
      }

      for (let i = 0; i < this.draftMail.emailAccounts.length; i++) {
        let isWrongFormatEmail = this.validateFormatEmail(
          this.draftMail.emailAccounts[i].emailAccount
        );
        if (
          this.draftMail.emailAccounts[i].emailAccount &&
          isWrongFormatEmail
        ) {
          if (this.isWrongFormatEmail.includes(i)) {
            continue;
          }

          this.isWrongFormatEmail.push(i);
        } else {
          const indexOfMail = this.isWrongFormatEmail.indexOf(i);
          if (indexOfMail !== -1) {
            this.isWrongFormatEmail.splice(indexOfMail, 1);
          }
        }
      }

      for (let i = 0; i < this.draftMail.emailAccounts.length; i++) {
        if (
          this.isWrongFormatEmail.includes(i) ||
          this.lengthErrorEmails.includes(i)
        ) {
          continue;
        }

        this.mail.emailAccounts[i].emailAccount =
          this.draftMail.emailAccounts[i].emailAccount;
      }

      this.checkError();
    },

    addEmail() {
      this.draftMail.emailAccounts.push({
        emailAccount: "",
      });
    },

    addEmailReplace(type) {
      switch (type) {
        case ITEM_ENTRY:
          this.computedMailReplace.push({
            keyReplace: "",
            itemReplace: "",
            itemReplaces: [],
          });
          break;
        case ITEM_JOB:
          this.computedMailReplaceJob.push({
            keyReplace: "",
            itemReplace: "",
            itemReplaces: [],
          });
          break;
        case ITEM_DISPATCH_JOB:
          this.computedMailReplaceDispatch.push({
            keyReplace: "",
            itemReplace: "",
            itemReplaces: [],
          });
          break;
      }
    },

    removeEmail(index) {
      this.draftMail.emailAccounts.splice(index, 1);
      this.validateInputEmail();
    },

    validateFormatEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(email).toLowerCase());
    },

    checkError() {
      this.computedMailError =
          this.lengthErrorSubject ||
          this.lengthErrorEmailSubject ||
          this.lengthErrorEmailErrorTitle ||
          this.lengthErrorBodyMail ||
          this.lengthErrorBodyMailJob ||
          this.lengthErrorBodyMailDispatch ||
          this.lengthErrorEmails.length > 0 ||
          this.isWrongFormatEmail.length > 0 ||
          this.lengthErrorReplaceKeys.length > 0 ||
          this.lengthErrorReplaceKeysJob.length > 0 ||
          this.lengthErrorReplaceKeysDispatch.length > 0 ||
          this.formatErrorReplaceKeys.length > 0 ||
          this.formatErrorReplaceKeysJob.length > 0 ||
          this.formatErrorReplaceKeysDispatch.length > 0 ||
          this.errorAccount ||
          this.hasKeyDuplicate ||
          this.hasKeyDuplicateJob ||
          this.hasKeyDuplicateDispatch ||
          this.isExistJobFormError ||
          this.isExistDispatchFormError;
    },

    async refreshResourceList() {
      await this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button " +  screenLabelsProperties.REFRESH_RESOURCE_BUTTON
      );

      this.$emit("refreshHumanResourceList", this.log.hash);
    },

    async refreshJobResourceList() {
      await this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button " +  screenLabelsProperties.REFRESH_RESOURCE_BUTTON
      );
      this.$emit("refreshJobResourceList", this.log.hash);
    },

    async refreshDispatchJobResourceList() {
      await this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button " +  screenLabelsProperties.REFRESH_RESOURCE_BUTTON
      );
      this.$emit("refreshDispatchJobResourceList", this.log.hash);
    },

    getHumanResourceFields() {
      this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button search " +  screenLabelsProperties.SEARCH_LABEL
      );
      this.$emit("getHumanResourceFields", this.log.hash);
    },

    getJobResourceFields() {
      this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button search " +  screenLabelsProperties.SEARCH_JOB_LABEL
      );
      this.$emit("getJobResourceFields", this.log.hash);
    },

    getDispatchJobResourceFields() {
      this.setLoggerData(
        "Menu " + generalLabelProperties.SECOND_TAB + " - Tab " + entryLabelProperties.MAIL_TAB_TITLE + " - Click button search " +  screenLabelsProperties.SEARCH_JOB_LABEL
      );
      this.$emit("getDispatchJobResourceFields", this.log.hash);
    },

    validateInputAccount() {
      this.errorAccount = !this.draftMail.user || !this.draftMail.user.email;
      this.checkError();
    },

    async setLoggerData(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
    },

    checkEmptyResourceCategory(resources, name, isEntry){
      if (isEntry) {
        return resources.filter(resource => resource.property_category_name === name && resource.isUsed && resource.name !== "files" && resource.name !== "photo" && name !== "photo_and_files").length !== 0;
      }

      return resources.filter(resource => resource.property_category_name === name && resource.isUsed && !resource.isUsedMailTab).length !== 0;
    },

    checkAvailableDragDrop(type) {
      switch (type) {
        case "entry":
          this.selectedItem = ITEM_ENTRY;
          break;
        case "job":
          this.selectedItem = ITEM_JOB;
          break;
        case "dispatch":
          this.selectedItem = ITEM_DISPATCH_JOB;
          break;
      }
    },

    warningDragDropItem(type) {
      Vue.$toast.clear();
      switch (type) {
        case ITEM_ENTRY:
          Vue.$toast.warning(
              entrySettingNotificationProperty.ENTRY_DROP_FAIL, {
                position: "bottom-right",
                duration: 3000,
              }
          );
          break;
        case ITEM_JOB:
          Vue.$toast.warning(
              entrySettingNotificationProperty.JOB_RESOURCE_DROP_FAIL, {
                position: "bottom-right",
                duration: 3000,
              }
          );
          break;
        case ITEM_DISPATCH_JOB:
          Vue.$toast.warning(
              entrySettingNotificationProperty.DISPATCH_JOB_RESOURCE_DROP_FAIL, {
                position: "bottom-right",
                duration: 3000,
              }
          );
          break;
      }
    },

    checkEmptyForm() {
      let existFormJob = this.jobResourceFields.filter(resource => resource.isUsed).length !== 0;
      let existItemReplaceJob = this.computedMailReplaceJob.filter(mailReplace => {
        if (!mailReplace.itemReplaces) {
          mailReplace.itemReplaces = [];
        }

        return mailReplace.itemReplaces.length > 0;
      }).length === 0;

      this.isExistJobFormError = !existFormJob && !(existItemReplaceJob && this.draftMail.emailBodyJob.length === 0) && this.hp_renkei_job === 1;
      let existFormDispatch = this.dispatchJobResourceFields.filter(resource => resource.isUsed).length !== 0;
      let existItemReplaceDispatch = this.computedMailReplaceDispatch.filter(mailReplace => {
        if (!mailReplace.itemReplaces) {
          mailReplace.itemReplaces = [];
        }

        return mailReplace.itemReplaces.length > 0;
      }).length === 0;

      this.isExistDispatchFormError = !existFormDispatch && !(existItemReplaceDispatch && this.draftMail.emailBodyDispatch.length === 0) && this.is_plan_dispatch_basic === 1 && this.hp_renkei_job === 1;
      this.checkError();
    },

    cloneResource(resource) {
      resource.resourceType = ITEM_ENTRY;
      return resource;
    },

    cloneResourceJob(resource) {
      resource.resourceType = ITEM_JOB;
      return resource;
    },

    cloneResourceDispatch(resource) {
      resource.resourceType = ITEM_DISPATCH_JOB;
      return resource;
    }
  },
};
</script>

<style scoped>
.setting_options_search {
  position: initial;
  height: 43px !important;
  border-bottom: unset !important;
}
.setting_options_search_customize {
  top: 42px !important;
  border-bottom: 1px solid #ddd !important;
}
.setting_options_search_job_resource {
  background-color: #fff;
  padding: 16px;
  height: 45px;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.setting_content_sub {
  padding-top: 0px !important;
  min-height: unset !important;
}

.setting_mail_input_replace {
  display: flex !important;
  padding-top: 15px;
}

.setting_unit_label_customize {
  width: 400px;
  margin-right: 16px;
  font-size: 13px;
  font-weight: bold;
}

.setting_draagle_item {
  width: 100% !important;
}

.setting_options_wrapper {
  height: calc(50vh - 60px - 26px - 24px - 40px - 136px) !important;
  border-bottom: 1px solid #ddd !important;
}

.setting_key_replace {
  min-width: 400px;
  width: 400px;
}
.setting_balloon_rows_label {
  min-width: 188px !important;
  max-width: 188px !important;
  font-weight: bold;
  font-size: 13px;
}
.customize_unit {
  border-bottom: unset !important;
}
.modify_setting_item {
  min-height: unset !important;
  padding: unset !important;
}
.setting_unit_add {
  margin-top: 5px !important;
}
.item_deleted{
  color: red !important;
}
.setting_job_resource{
  border-top: 1px solid #ddd;
}
.justify-content-end{
  justify-content: space-between !important;
}
.entry_mail_setting{
  margin-top: 20px;
}
</style>
